// extracted by mini-css-extract-plugin
export default {"leftBox":"spatialMap_leftBox__6g+-B","mapBox":"spatialMap_mapBox__G6Us9"};